import { h } from 'preact';
import { Text } from 'preact-i18n';

import VariantPills from './variantPills';

// Buy box shown in the product drawer to visitors who are NOT logged in when
// the shop supports the guest basket (see product/view.js showGuestBuy()).
// Mirrors the logged-in box: colour/size must be chosen before adding, and
// out-of-stock products cannot be added.
const GuestBuyBox = ({
    product = {},
    color = '',
    size = '',
    count = 0,
    added = false,
    otherShop = false,
    onAdd = () => {},
    onOpenCart = () => {},
    onSelectColor = () => {},
    onSelectSize = () => {},
}) => {
    const hasColors = Array.isArray(product.colors) && product.colors.length > 0;
    const hasSizes = Array.isArray(product.sizes) && product.sizes.length > 0;
    const inStock = product.inStock > 0;
    const needsVariant = (hasColors && !color) || (hasSizes && !size);

    return (
        <div class='flex-fill d-flex flex-column px-3 py-3 mt-3 justify-content-center align-items-center'>
            {inStock && hasColors && <VariantPills
                title={<Text id='product.select-color'>Select color</Text>}
                options={product.colors}
                selected={color}
                onSelect={onSelectColor}
            />}
            {inStock && hasSizes && <VariantPills
                title={<Text id='product.select-size'>Select size</Text>}
                options={product.sizes}
                selected={size}
                onSelect={onSelectSize}
            />}

            {otherShop && <div class='alert alert-warning py-2 mb-2'>
                <Text id='guestCart.other-shop'>This product belongs to another shop.</Text>
            </div>}
            {added && !otherShop && <div class='text-success mb-2'>
                <i class='fa-solid fa-check me-1' /><Text id='guestCart.added'>Added to basket</Text>
            </div>}

            <div class='d-flex flex-row flex-wrap justify-content-center align-items-center gap-2'>
                {count > 0 && <button
                    type='button'
                    class='btn btn-success btn-lg rounded-pill'
                    onClick={onOpenCart}
                >
                    <i class='fa-duotone fa-basket-shopping' /> <Text id='guestCart.goto-basket'>Go to basket</Text> <span class='badge text-bg-light'>{count}</span>
                </button>}

                {inStock ? <button
                    type='button'
                    disabled={needsVariant}
                    class='btn btn-primary btn-lg rounded-pill'
                    onClick={onAdd}
                >
                    <i class='fa-duotone fa-cart-plus' /> <Text id='guestCart.add-to-basket'>Add to basket</Text>
                </button> : <button
                    type='button'
                    class='btn btn-danger btn-lg rounded-pill'
                    disabled
                >
                    <i class='fa-duotone fa-cart-plus' /> <Text id='product.out-of-stock'>Out of stock</Text>
                </button>}
            </div>
            <small class='text-body-secondary mt-2'>
                <Text id='guestCart.no-account-needed'>No account needed. We only use your details for this order.</Text>
            </small>
        </div>
    );
};

export default GuestBuyBox;
